// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Image.module.scss  */
.Image-module-Root_2dZ {
  display: inline-block;
  visibility: hidden;
  object-fit: contain;
  object-position: center; }

.Image-module-Control_370 {
  position: relative;
  display: inline-block;
  margin: 0;
  padding: 0; }

.Image-module-loaded_k4J {
  visibility: visible; }

.Image-module-animated_yhe {
  animation: Image-module-fadeIn_3Me 0.1s ease forwards; }

@keyframes Image-module-fadeIn_3Me {
  from {
    opacity: 0; }
  to {
    opacity: 1; } }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Image/Image.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB,EAAE;;AAE3B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,UAAU,EAAE;;AAEd;EACE,mBAAmB,EAAE;;AAEvB;EACE,qDAAqD,EAAE;;AAEzD;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE","sourcesContent":["/*  imported from Image.module.scss  */\n.Image-module-Root_2dZ {\n  display: inline-block;\n  visibility: hidden;\n  object-fit: contain;\n  object-position: center; }\n\n.Image-module-Control_370 {\n  position: relative;\n  display: inline-block;\n  margin: 0;\n  padding: 0; }\n\n.Image-module-loaded_k4J {\n  visibility: visible; }\n\n.Image-module-animated_yhe {\n  animation: Image-module-fadeIn_3Me 0.1s ease forwards; }\n\n@keyframes Image-module-fadeIn_3Me {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
